import {SET_ACTIVE_PLANT} from '../actionTypes';

export const acivePlantDispatcher = (plantId) => {
  return {
    type: SET_ACTIVE_PLANT,
    payload: {plantId},
  };
};
